import React, { useCallback, useEffect, useState } from "react";
import { Compass, Sparkles } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "../lib/api";

const STATUS = {
  planned: "Planned",
  in_progress: "In progress",
  completed: "Recently completed",
};

export default function RoadmapPage() {
  const [items, setItems] = useState(null);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/roadmap");
      setItems(data.items || []);
    } catch (error) {
      toast.error(formatApiError(error.response?.data?.detail));
      setItems([]);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  if (items === null)
    return (
      <div className="mx-auto max-w-[1200px] px-6 py-10 lg:px-10 eyebrow">
        Loading roadmap…
      </div>
    );

  return (
    <div
      className="mx-auto max-w-[1200px] px-6 py-10 md:py-12 lg:px-10"
      data-testid="roadmap-page"
    >
      <div className="border-b pb-8" style={{ borderColor: "var(--border)" }}>
        <div className="eyebrow mb-2 flex items-center gap-2">
          <Compass size={13} /> Looking ahead
        </div>
        <h1
          className="font-heading font-black text-4xl md:text-5xl leading-none tracking-tight"
          style={{ color: "var(--ink)" }}
        >
          Roadmap
        </h1>
        <p className="mt-3 max-w-2xl text-sm" style={{ color: "var(--muted)" }}>
          A directional view of improvements Employees First is preparing for
          employers.
        </p>
      </div>

      {!items.length ? (
        <div
          className="mt-8 border px-6 py-12 text-center"
          style={{ borderColor: "var(--border)", background: "var(--surface)" }}
          data-testid="roadmap-empty-state"
        >
          <Sparkles
            size={20}
            className="mx-auto mb-4"
            style={{ color: "var(--muted)" }}
          />
          <div
            className="font-heading text-xl font-bold"
            style={{ color: "var(--ink)" }}
          >
            Updates are taking shape
          </div>
          <p
            className="mx-auto mt-2 max-w-md text-sm"
            style={{ color: "var(--muted)" }}
          >
            There are no published roadmap items to share right now. Please
            check back soon.
          </p>
        </div>
      ) : (
        <div
          className="mt-8 divide-y border"
          style={{ borderColor: "var(--border)", background: "var(--surface)" }}
          data-testid="roadmap-list"
        >
          {items.map((item) => (
            <article
              key={item.id}
              className="px-6 py-6"
              data-testid={`roadmap-item-${item.id}`}
            >
              <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
                <div>
                  <h2
                    className="font-heading text-2xl font-bold"
                    style={{ color: "var(--ink)" }}
                  >
                    {item.title}
                  </h2>
                  <p
                    className="mt-2 max-w-3xl text-sm leading-relaxed"
                    style={{ color: "var(--muted)" }}
                  >
                    {item.description}
                  </p>
                </div>
                <div className="flex shrink-0 gap-2">
                  <span
                    className="pill"
                    data-testid={`roadmap-horizon-${item.id}`}
                  >
                    {item.planning_horizon}
                  </span>
                  <span
                    className="pill"
                    data-testid={`roadmap-status-${item.id}`}
                  >
                    {STATUS[item.status] || "Planned"}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      )}
    </div>
  );
}
